// angular
import { NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// components
import { ButtonComponent } from '@app/core/components/button/button.component';
// environment
import { environment } from '@environments/environment';

@Component({
  selector: 'pwj-not-found',
  standalone: true,
  imports: [RouterModule, NgOptimizedImage, ButtonComponent, TranslateModule],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent implements OnInit {
  // time of auto navigate to home page
  public counter: number = 10;
  public currentDir!: string;

  // dependencies
  private readonly _router = inject(Router);
  private readonly _translateService = inject(TranslateService);

  constructor() {
    const currentLang = this._translateService.currentLang;

    this.currentDir =
      currentLang === 'fa' || currentLang === 'ar' || currentLang === 'ckb'
        ? 'rtl'
        : 'ltr';
  }

  ngOnInit(): void {
    // navigation timer
    const intervalId = setInterval(() => {
      this.counter--;

      if (this.counter === 0) {
        clearInterval(intervalId);
        this._router.navigate(['/']);
      }
    }, environment.notFoundTimeOut);
  }
}
